var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.205 16.92-.974 3.64-3.563.075A13.937 13.937 0 0 1 0 14c0-2.322.565-4.51 1.565-6.438h.001l3.172.581 1.389 3.152A8.322 8.322 0 0 0 5.677 14c0 1.028.187 2.012.528 2.92z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.755 11.385c.161.847.245 1.721.245 2.615 0 1.002-.105 1.98-.306 2.923a13.997 13.997 0 0 1-4.93 7.995v-.001l-3.995-.204-.565-3.53a8.344 8.344 0 0 0 3.59-4.26h-7.486v-5.538h13.447z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.764 24.917A13.94 13.94 0 0 1 14 28c-5.332 0-9.967-2.98-12.332-7.365l4.537-3.714a8.324 8.324 0 0 0 11.999 4.263l4.56 3.733z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.936 3.223-4.535 3.713a8.327 8.327 0 0 0-12.274 4.36l-4.56-3.734h-.002A13.997 13.997 0 0 1 14 0c3.397 0 6.512 1.21 8.936 3.223z",
    fill: "#F14336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ebd6bf2fb67714b3ee2c5f07a8c07d8c.svg";
export { ForwardRef as ReactComponent };